import { BaseEnum, BaseEnumValue } from '@/types'

export function getEnumOrdinal<T extends BaseEnumValue>(enumType: BaseEnum<T>, enumValue: T | null): number {
  const enumValueType = typeof enumValue

  return Object.values(enumType)
    .filter((enumTypeValue) => typeof enumTypeValue === enumValueType)
    .indexOf(enumValue as T)
}